import clsx from "clsx";
import { ACCOUNT_LIST } from "../constants/labeling.constants";
import { LabelItem } from "./LabelItem";
import { Account } from "@/entities/DataAssociation/Account.model";
import { SparklesIcon } from "@heroicons/react/24/outline";

export function AccountItem({
    account,
    recommended = false,
    onAccountSelection,
}: {
    account: Account;
    recommended?: boolean;
    onAccountSelection: (account: Account) => void;
}) {
    return (
        <li
            key={account.id}
            className={clsx(
                "card flex flex-col gap-2",
                recommended && "border-default mb-2 border",
            )}
            onClick={() => onAccountSelection(account)}
        >
            <div className="flex items-center justify-between">
                {account.accountName}
                {recommended && (
                    <SparklesIcon className="text-subdued size-4" />
                )}
            </div>
            <LabelItem listItem={false} label={ACCOUNT_LIST[account.label]} />
        </li>
    );
}
